import React from 'react';
import './BlogPost.css';

import logo from '../../images/wp.jpg';

class BlogPost2 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Sommerfest Schmäinghook!     -     08. September 2018</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Sommerfest Schmäinghook" src={logo} />
        </div>
        <div className="blogpost-text">
          Gestern durften wir mit der Besetzung Red Lines & Friends das Sommerfest des Schützenvereins Schmäinghook in Alstätte begleiten. Vielen Dank für diese richtig geniale Party! 
          Dazu gab es sogar noch einen <a href="https://www.wochenpostonline.de/news/detail/article/schmaeinghook-feiert-ausgelassen-das-sommerfest.html?tx_news_pi1[controller]=News&tx_news_pi1[action]=detail&cHash=b3d0be22b1c89ff0bc6d29e02dfebdfe">Zeitungsartikel</a> in der Wochenpost.
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost2;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost2.js